/**
 * Locations module constants.
 */
/** AspNetRights checked by CCMS.Api.LocationManagement (seeded / role-mapped by migration 261). */
export const LOCATION_RIGHTS = {
    View: 'Location.View',
    Create: 'Location.Create',
    Update: 'Location.Update',
    /** Archive + restore locations. */
    Delete: 'Location.Delete',
    AddressView: 'Location.Address.View',
    AddressCreate: 'Location.Address.Create',
    AddressUpdate: 'Location.Address.Update',
    AddressDelete: 'Location.Address.Delete',
    InfoView: 'Location.Info.View',
    InfoCreate: 'Location.Info.Create',
    InfoUpdate: 'Location.Info.Update',
    InfoDelete: 'Location.Info.Delete',
    ServiceTimeView: 'Location.ServiceTime.View',
    ServiceTimeCreate: 'Location.ServiceTime.Create',
    ServiceTimeUpdate: 'Location.ServiceTime.Update',
    /** Archive + restore service times. */
    ServiceTimeDelete: 'Location.ServiceTime.Delete',
    LeaderView: 'Location.Leader.View',
    LeaderCreate: 'Location.Leader.Create',
    LeaderUpdate: 'Location.Leader.Update',
    LeaderDelete: 'Location.Leader.Delete',
    VenueView: 'Location.Venue.View',
    VenueCreate: 'Location.Venue.Create',
    VenueUpdate: 'Location.Venue.Update',
    /** Archive + restore venues. */
    VenueDelete: 'Location.Venue.Delete',
    SocialMediaView: 'Location.SocialMedia.View',
    SocialMediaCreate: 'Location.SocialMedia.Create',
    SocialMediaUpdate: 'Location.SocialMedia.Update',
    SocialMediaDelete: 'Location.SocialMedia.Delete',
    /** Social accounts WITH credentials (also unlocks credentials in the location views). */
    SocialMediaAccountView: 'Location.SocialMediaAccount.View',
    /** Social accounts, public projection only. */
    SocialMediaAccountViewPublic: 'Location.SocialMediaAccount.ViewPublic',
    SocialMediaAccountCreate: 'Location.SocialMediaAccount.Create',
    SocialMediaAccountUpdate: 'Location.SocialMediaAccount.Update',
    SocialMediaAccountDelete: 'Location.SocialMediaAccount.Delete',
};
/** Roles that open the Locations module (migration 261). Admin passes every Location endpoint. */
export const LOCATION_ROLES = {
    Admin: 'Admin',
    /** All Location.* rights. */
    LocationsAdmin: 'LocationsAdmin',
    /** Read-only rights (no social credentials). */
    LocationsAccess: 'Locations Access',
};
/** ServiceTime.dayOfWeek values (0 = Sunday). */
export const LOCATION_DAYS_OF_WEEK = [
    { value: 0, label: 'Sunday', short: 'Sun' },
    { value: 1, label: 'Monday', short: 'Mon' },
    { value: 2, label: 'Tuesday', short: 'Tue' },
    { value: 3, label: 'Wednesday', short: 'Wed' },
    { value: 4, label: 'Thursday', short: 'Thu' },
    { value: 5, label: 'Friday', short: 'Fri' },
    { value: 6, label: 'Saturday', short: 'Sat' },
];
/** Codes returned in `errors[0]` of a 409 from LocationManagement. */
export const LOCATION_CONFLICT_CODES = {
    LocationNameTaken: 'location_name_taken',
    LocationArchived: 'location_archived',
    AddressExists: 'address_exists',
    ServiceTimeExists: 'service_time_exists',
    ServiceTimeArchived: 'service_time_archived',
    VenueNameTaken: 'venue_name_taken',
    VenueArchived: 'venue_archived',
    LeaderExists: 'leader_exists',
    InfoNameTaken: 'info_name_taken',
    SocialAccountExists: 'social_account_exists',
    PlatformNameTaken: 'platform_name_taken',
    PlatformInUse: 'platform_in_use',
};
//# sourceMappingURL=LocationConstants.js.map